import { AddPdfResponse } from '@models/AddPdfRequest'
import { AddLibrariesRequest } from '@models/libraries'

// A API grava o PDF com um nome gerado (`fileName`) e devolve o nome enviado em
// `originalName`; versões antigas da API só mandam `fileName`.
export default function uploadedPdfFiles(
	uploaded: AddPdfResponse['pdfsArray']
): AddLibrariesRequest['pdfFiles'] {
	return uploaded.map((item) => ({
		name: item.originalName ?? item.fileName,
		file: item.fileName,
		deleted: false,
	}))
}
